import { FormService } from '../../mappers/serviceMapper/service.mapper';
import { SlotAddOnGroup } from '../types';
import { ListAddOnGroupsByServiceIdResponse } from '@wix/ambassador-bookings-services-v2-service/types';
import { QueryAddOnsResponse } from '@wix/ambassador-addons-v1-add-on/types';

export const mapAddonGroups = ({
  service,
  addonsPerGroup,
  preSelectedAddon,
}: {
  service: FormService;
  addonsPerGroup?: ListAddOnGroupsByServiceIdResponse;
  preSelectedAddon?: QueryAddOnsResponse;
}): SlotAddOnGroup[] | undefined => {
  if (!addonsPerGroup && preSelectedAddon) {
    return service.addonsGroup?.map((group) => {
      return {
        id: group.id!,
        name: group.name!,
        addOns: group.addOnIds?.map((addOnId) => {
          const addOn = preSelectedAddon?.addOns?.find(
            (addon) => addon.id === addOnId,
          );
          return {
            id: addOnId,
            name: addOn?.name,
            price: addOn?.price?.value,
            duration: addOn?.durationInMinutes,
            currency: addOn?.price?.currency || 'USD',
          };
        }),
      };
    });
  }
  return addonsPerGroup?.addOnGroupsDetails?.map((group) => {
    return {
      id: group.groupId,
      name: group.groupNameTranslated || group.groupName,
      prompt: group.promptTranslated || group.prompt,
      maxNumberOfAddOns: group.maxNumberOfAddOns,
      addOns: group.addOns?.map((addon) => {
        return {
          id: addon.addOnId,
          name: addon.nameTranslated || addon.name,
          price: addon.price?.value,
          duration: addon.durationInMinutes,
          maxQuantity: addon.maxQuantity,
          currency: addon.price?.currency || 'USD',
        };
      }),
    };
  });
};
